const CodeBlueViewerMenu = [
    {
      icon: "summarize",
      key: "Code.Blue.Reports",
      name: "Code Blue Reports",
      url: "home/app/Code-Blue-Reports",
      description: "",
      productionReady: true,
    },
  ];
  
  export { CodeBlueViewerMenu };
  